import { useEffect } from 'react'
import './ChartCard.scss'
import moment from 'moment/moment'
import classNames from 'classnames'
import { PROVIDER_EVENT_NAMES, tracking } from 'lib/segment/tracking'
import upIcon from '../../../../../images/common/chevronUp.png'

export const ChartCard = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  title,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  image,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  additionalImageIconStyle,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  lastUpdate,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  rightButton,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  showInfo,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  data,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  renderInfo,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  emptyText,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  extraView,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  toggleShowInfo,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  extraEditView,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  chartCardId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isWithNewIndicator,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isWithoutSeparatedLine,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isWithoutLastUpdate,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isAlwaysCollapsed,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  minimalExpandedHeight,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  minimalHeightWithNewSection,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientInfo,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  chartCardHeaderContainerAdditionalClassName,
  className = '',
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  additionalChartCardStyle,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  children,
  showEmpty = true,
}) => {
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  function handleToggleShowInfo(value) {
    toggleShowInfo(value)

    if (value) {
      const { PatientId, VisitSummary } = patientInfo

      tracking.trackEvent(PROVIDER_EVENT_NAMES.EXPAND_DETAILS_IN_PATIENT_CHART, {
        PatientId,
        Section: title,
        PatientPastVisitCount: VisitSummary?.CountPast,
        PatientUpcomingVisitCount: VisitSummary?.CountUpcoming,
      })
    }
  }

  useEffect(() => {
    const chartCardContainer = document.getElementById(chartCardId)
    if (chartCardContainer) {
      if (!showInfo) {
        chartCardContainer.style.height = '80px'
      } else {
        chartCardContainer.style.height = ''
      }
    }
  }, [chartCardId, showInfo])

  const chartCardMinHeightByCondition =
    showInfo ?
      extraView || extraEditView ?
        minimalHeightWithNewSection
      : minimalExpandedHeight
    : 80

  const toggleCollapseIconStyle = {
    rotate: showInfo ? null : '180deg',
    visibility: isAlwaysCollapsed ? 'hidden' : 'visible',
  }

  return (
    <div
      className={classNames('chart-card-container', { [className]: className })}
      id={chartCardId}
      style={{
        minHeight: chartCardMinHeightByCondition,
        maxHeight: chartCardMinHeightByCondition,
        ...additionalChartCardStyle,
      }}>
      <div className={`chart-card-header-container ${chartCardHeaderContainerAdditionalClassName}`}>
        <div className='chart-card-header-left'>
          <img src={image} className='chart-card-header-logo' alt='section logo' style={additionalImageIconStyle} />
          <div className='chart-card-header-title-date-container'>
            <span className='chart-card-header-text bold'>{title}</span>
            <span style={{ visibility: isWithoutLastUpdate ? 'hidden' : 'visible' }} className='chart-card-header-text'>
              Last updated: {lastUpdate ? moment(lastUpdate).format('MMM DD YYYY') : '--'}
            </span>
          </div>
        </div>

        <div className='chart-card-header-right'>
          {isWithNewIndicator ?
            <div className='chart-card-new-indicator'>New!</div>
          : null}
          {rightButton}
          <img
            role='presentation'
            src={upIcon}
            className='chart-card-header-up-icon'
            alt='toggle view'
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            style={toggleCollapseIconStyle}
            onClick={() => handleToggleShowInfo(!showInfo)}
          />
        </div>
      </div>
      {showInfo ?
        <div className='chart-card-data-container' id={`chartCardContainer${title}`}>
          {data.length || !showEmpty ?
            <>
              {extraView ? extraView() : null}
              {extraEditView ? extraEditView(true) : null}
              {renderInfo?.()}
              {children}
            </>
          : showEmpty && (
              <>
                {extraView ? extraView() : null}
                {extraEditView ? extraEditView(true) : null}
                <span className='chart-card-no-records'>{emptyText}</span>
              </>
            )
          }
        </div>
      : null}
      {!isWithoutSeparatedLine && <div className='patient-chart-card-line' />}
    </div>
  )
}
